import { useTranslation } from 'react-i18next';

import { DataPanel, DataPanelItem, DataPanelRow } from '@/ui';
import { AppType } from '@/signalr';
import type { AppInfo } from '@/signalr';

const APP_TYPE_NAMES: Record<AppType, string> = {
  [AppType.Mobile]: 'Mobile',
  [AppType.Web]: 'Web',
  [AppType.IOT]: 'IOT',
};

export type AppInfoPanelProps = {
  appInfo: AppInfo;
};

export function AppInfoPanel({ appInfo }: AppInfoPanelProps) {
  const { t } = useTranslation();

  return (
    <DataPanel header={t('Incident_InfoPanel_ApplicationInfo')}>
      <DataPanelRow>
        <DataPanelItem title={t('Incident_InfoPanel_ApplicationType')} value={APP_TYPE_NAMES[appInfo.type]} />
        <DataPanelItem title={t('Incident_InfoPanel_ApplicationCode')} value={appInfo.code} />
      </DataPanelRow>
      <DataPanelRow>
        <DataPanelItem title={t('Incident_InfoPanel_ApplicationVersion')} value={appInfo.version} />
        <DataPanelItem title={t('Incident_InfoPanel_ApplicationLanguage')} value={appInfo.language ?? undefined} />
      </DataPanelRow>
    </DataPanel>
  );
}
